import MyDataHelps from "@careevolution/mydatahelps-js"

export default function getFitbitProviderID() {
	var fitbitProviderID = 564;
	if (!MyDataHelps.baseUrl || MyDataHelps.baseUrl.startsWith("https://mdhorg.ce.dev")) {
		fitbitProviderID = 2;
	}
	return fitbitProviderID;
}